import PropTypes from "prop-types";
import React from "react";

import { useDeviceInfo, XLARGE } from "@swa-ui/browser";
import { Layout } from "@swa-ui/core";
import { usePlacementIds } from "@swa-ui/placements";

import { SpecialOffersCard } from "../SpecialOffersCard";

export const SpecialOffersSection = (props) => {
  const { placement } = props;
  const placementIds = usePlacementIds(new RegExp(`${placement?.id}.*`));
  const { screenSize } = useDeviceInfo();

  return (
    placementIds.length > 0 && (
      <Layout {...getLayoutProps()}>
        <SpecialOffersCard placementIds={placementIds} />
      </Layout>
    )
  );

  function getLayoutProps() {
    return {
      bottom: "medium",
      center: screenSize === XLARGE,
      sides: true,
      top: "large",
    };
  }
};

SpecialOffersSection.displayName = "SpecialOffersSection";
SpecialOffersSection.propTypes = {
  /** Object that displays placement content. */
  placement: PropTypes.object,
};
